import type { CSSProperties } from 'react'

const transparencyCheckerboardStyle: CSSProperties = {
  backgroundColor: '#fff',
  backgroundImage: [
    'linear-gradient(45deg, #cccccc 25%, transparent 25%)',
    'linear-gradient(-45deg, #cccccc 25%, transparent 25%)',
    'linear-gradient(45deg, transparent 75%, #cccccc 75%)',
    'linear-gradient(-45deg, transparent 75%, #cccccc 75%)',
  ].join(','),
  backgroundSize: '10px 10px',
  backgroundPosition: '0 0, 0 5px, 5px -5px, -5px 0',
}

export default transparencyCheckerboardStyle
